import React, { useMemo, useState } from 'react';
import { Field, Area, Check, useEmit } from './fields';

const ITEMS = [
    ['scaffolding', 'Scaffolding'],
    ['mobileCrane', 'Mobile Crane'],
    ['forklift', 'Forklift'],
    ['mewp', 'Mobile Elevating Work Platform (MEWP)'],
    ['othersEquipment', 'Others'],
];

/** Emits { <item>: 'yes'|'no', naEquipment, comments, selectedEquipments }. */
const OtherEquipment = ({ onDataChange }) => {
    const [state, setState] = useState({});
    const [na, setNa] = useState(false);
    const [comments, setComments] = useState('');

    const data = useMemo(() => {
        const out = { naEquipment: na ? 'yes' : 'no', comments };
        const selected = [];
        for (const [key, label] of ITEMS) {
            const on = !na && !!state[key];
            out[key] = on ? 'yes' : 'no';
            if (on) selected.push(label);
        }
        out.selectedEquipments = na ? 'Not Applicable' : selected.join(', ');
        return out;
    }, [state, na, comments]);
    useEmit(data, onDataChange);

    const toggle = (key, val) => { setState((p) => ({ ...p, [key]: val })); if (val) setNa(false); };
    const toggleNa = (val) => { setNa(val); if (val) setState({}); };

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">Equipment Required</h6></div>
            <div className="v3-wp-checks">
                {ITEMS.map(([key, label]) => (
                    <Check key={key} id={`eqp-${key}`} label={label} checked={!!state[key]} onChange={(v) => toggle(key, v)} />
                ))}
                <Check id="eqp-na" label="Not Applicable" checked={na} onChange={toggleNa} />
            </div>
            {!na && (
                <div className="v3-wp-grid" style={{ marginTop: 12 }}>
                    <Field label="Comments" full><Area value={comments} onChange={setComments} rows={2} /></Field>
                </div>
            )}
        </div>
    );
};

export default OtherEquipment;
